import $ from 'jquery';
import Slick from 'slick-carousel';

/**
 * Slider plugin - slick based
 */
export default class Slider {
    /**
     * @param $slider Slider container. Wrapper for trigger and content
     * @param options Additional options
     */
    constructor($slider, $sliderParams, options = {}) {
        this.options = $.extend(true, {
            classes: {},
        }, options);

        if (!$slider) {
            return;
        }

        this.$slider = $slider;
        this.$sliderParams = $sliderParams;

        this.init();
    }

    init() {
        this.initSlider();
    }

    initSlider() {
        $(this.$slider).slick(this.$sliderParams);
    }
}



// WEBPACK FOOTER //
// ./front/treasurybond/js/common/slider.js